import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { BlogProvider } from './contexts/BlogContext'; // Importujeme BlogProvider
import { useCart } from './contexts/CartContext';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import CarsGallery from './pages/CarsGallery';
import CarDetail from './pages/CarDetail';
import EventsCalendar from './pages/EventsCalendar';
import FullGallery from './pages/FullGallery';
import Shop from './pages/Shop';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import AchievementsGallery from './pages/AchievementsGallery';
import Blog from './pages/Blog'; // Import stránky se seznamem blogových příspěvků
import BlogDetail from './pages/BlogDetail'; // Import stránky s detailem blogového příspěvku
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Cookies from './components/Cookies';
import CookieConsent from './components/common/CookieConsent';
import CartNotification from './components/common/CartNotification';
import ProductDetail from './pages/ProductDetail';

// This component uses the cart context
function AppContent() {
  const { cartNotification, closeNotification } = useCart();
  
  return (
    <div className="flex flex-col min-h-screen">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cars-gallery" element={<CarsGallery />} />
        <Route path="/car/:slug" element={<CarDetail />} />
        <Route path="/events-calendar" element={<EventsCalendar />} />
        <Route path="/gallery" element={<FullGallery />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/achievements-gallery" element={<AchievementsGallery />} />
        {/* Nové trasy pro blog */}
        <Route path="/blog" element={<BlogProvider><Blog /></BlogProvider>} />
        <Route path="/blog/:slug" element={<BlogProvider><BlogDetail /></BlogProvider>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <CookieConsent /> {/* Přidáno na konec, aby bylo viditelné na všech stránkách */}
      <CartNotification
        isVisible={cartNotification.isVisible}
        onClose={closeNotification}
        productName={cartNotification.productName}
      />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <AppContent />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;